import { Platform } from '../platforms/platform'
import { PlatformBase } from '../platforms/platform-base'
import { PlatformLG } from '../platforms/platform-lg'
import { PlatformVizio } from '../platforms/platform-vizio'
import { PlatformComcast } from '../platforms/platform-comcast'
import { PlatformVidaa } from '../platforms/platform-vidaa'
import { PlatformFireTV } from '../platforms/platform-firetv'
import { AppParams } from './app-params'
import { AppState } from './app-state'
import { Config } from './config'
import { PLATFORM } from './enum'
import { PlatformSamsung } from '../platforms/platform-samsung'
import { CCConfig } from './cc-config'

export interface IAppSetup {
  appParams: AppParams | undefined
  appConfig: Config | undefined
  platform: Platform | undefined
  appState: AppState | undefined
  ccOptions: CCConfig
}

export class AppSetup implements IAppSetup {
  appParams: AppParams | undefined
  appConfig: Config | undefined
  platform: Platform | undefined
  appState: AppState | undefined
  ccOptions!: CCConfig

  setAppConfig(appParams: AppParams) {
    this.appParams = appParams
    const { _rootConfig, devParams } = window
    if (_rootConfig && devParams) {
      // if samsung get the param from the hybrid script
      appParams.siteId = _rootConfig.siteId
      appParams.platform_id = _rootConfig.auth_token
      if (devParams && devParams.debug) {
        appParams.debugConsole = devParams.debug
        appParams.buildVer = devParams.buildVer
        appParams.testAdMode = devParams.testAdMode
        appParams.testAdsIds = devParams.testAdsIds
        appParams.testAdsProviders = devParams.testAdsProviders
        appParams.testIMAAdPodding = devParams.testIMAAdPodding
        appParams.testCountry = devParams.testCountry
        appParams.apiEnv = devParams.apiEnv
        appParams.nodeEnv = devParams.nodeEnv
        appParams.env = devParams.env
        appParams.testAppResumeTime = devParams.testAppResumeTime
        appParams.testWebp = devParams.testWebp
        appParams.testIMAMacro = devParams.testIMAMacro
      }
    }
    this.appConfig = new Config(appParams)
    this.appState = new AppState(this.appConfig)
  }

  createPlatform() {
    if(this.appConfig?.platform_id == '') {
      this.appConfig.platform_id = '1217563'
    }
    switch (this.appConfig?.platform_id) {
      case PLATFORM.LG:
        //adding this for XFIN-1763 - to reduce the Option request on rapi.
        this.appConfig.enableDirectApiCall = false
        this.appConfig.enableGestureListener = true
        this.platform = new PlatformLG()
        break
      case PLATFORM.VIZIO:
        this.platform = new PlatformVizio()
        break
      case PLATFORM.SAMSUNG:
        this.platform = new PlatformSamsung()
        break
      case PLATFORM.COMCAST:
      case PLATFORM.COX:
      case PLATFORM.ROGERS:
      case PLATFORM.PLATCO:
      case PLATFORM.SHAW:
        this.platform = new PlatformComcast()
        this.appConfig.enableDirectApiCall = false
        //this.platform._shouldShowExitPopup = true
        break
      case PLATFORM.VIDAA:
        this.platform = new PlatformVidaa()
        break
      // VegaOS (FireTV) - use the FireTV platform implementation
      case PLATFORM.FIRETV:
        this.platform = new PlatformFireTV()
        this.appConfig.enableDirectApiCall = false
        break      
      default:
        this.platform = new PlatformBase()
    }
    window.platform = this.platform
  }

  initCCOptions() {
    this.ccOptions = new CCConfig()
    this.ccOptions.init(this)
  }
}
